/* NOTIFICATION */

export const UPDATE_SOCKET_NOTIFICATION = "UPDATE_SOCKET_NOTIFICATION";

export const RESET_SOCKET_NOTIFICATION = "RESET_SOCKET_NOTIFICATION";

export const GET_SOCKET_NOTIFICATION = "GET_SOCKET_NOTIFICATION";
export const GET_SOCKET_NOTIFICATION_SUCCESS = "GET_SOCKET_NOTIFICATION_SUCCESS";
export const GET_SOCKET_NOTIFICATION_FAIL = "GET_SOCKET_NOTIFICATION_FAIL";
